<template>
  <div>
    <el-dialog
      title="批量修改商家"
      width="20%"
      :visible.sync="isShow"
      :before-close="handleCLose"
    >
      <el-form :model="form">
        <el-form-item>
          <el-upload
            ref="supplyfile"
            :action="action"
            :file-list="fileList"
            :auto-upload="true"
            :limit="1"
            :on-success="handleSuccess"
            with-credentials
          >
            <el-button size="mini" type="primary"> 选择文件 </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import rules from "@/const/rules.js";

export default {
  name: "ImportSupplyFileDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules,
      form: {},
      fileList: [],
      isShow: false,
      action: `${apiBaseURL}/erp/Supply/importSupplyUpdateFile`,
    };
  },
  watch: {
    show() {
      this.isShow = this.show;
    },
  },
  methods: {
    handleSuccess(res) {
      if (res.code === 200) {
        window.open(apiBaseURL + res.data.file);
      } else {
        this.$message.e(res.msg);
      }
      this.$refs.supplyfile.clearFiles();
    },

    handleCLose() {
      this.$emit("close", {
        refresh: true,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/components/ImportSupplyFileDialog.vue